import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueMeta from 'vue-meta'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import 'default-passive-events'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
// el-dialog的拖拽功能
import '@/directive/el-dialog.js'

Vue.use(ElementUI)
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Select.props.defaultFirstOption.default = true
ElementUI.Select.props.filterable.default = true
ElementUI.Select.props.clearable.default = true

Vue.use(VueDirectiveImagePreviewer)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
